module.exports = __webpack_public_path__ + "files/0b1eac6e134a5c3325ad76a609341a6d.png";